<template>
    <div class="container-fluid m-0 p-0">

        <div class="row m-0">
            <SidebarMenu
                :logo="G.systemData.logo && G.systemData.logo.value ? G.systemData.logo.value : '/assets/images/noimg.png'"
                :title="G.projectSubtitle"
                :theme="G.theme"
                :width="260"
                :menus="menu_list"
                :setComponent="setComponent"
                :defaultSelectedMenu="G.defaultSelectedMenu"
                :footerMenu="true"
                :footerMenuText="'CASRA Group MMC'"
                :footerMenuMiniText="'CASRA'"
            />

            <div class="col main-content px-0">

                <Navbar :theme="G.theme" class="py-30" />
                <OffCanvas />
                <main class="main-body-content">

                    <keep-alive>
                        <component :is="loadPages" :data="currentComponent"></component>
                    </keep-alive>

                </main>
                <Footer :theme="G.theme" class="fixed-bottom1" />
            </div>
        </div>

        <template v-if="G.dynModal.components.length">
            <template v-for="item in G.dynModal.components" :key="item._id">
                <component :is="'ModalController'" :data="item"></component>
            </template>
        </template>

    </div>


</template>


<script>
    import { ref, computed, defineAsyncComponent, onBeforeMount, onMounted } from "vue";

    import { useRouter } from "vue-router";
    import { useStore } from "@/store";

    import Navbar from "@/components/navbar/Navbar";
    import OffCanvas from "@/components/navbar/OffCanvas";
    // import Sidebar from "@/components/sidebar/Sidebar";
    import SidebarMenu from "@/components/sidebar/SidebarMenu";
    import Footer from "@/components/footer/FooterSimple";
    // import Modal from "@/components/modal/Modal";
    import ModalController from "@/components/modal/ModalController";

    import { menus } from "@/data/sidebarmenu";
    import { G, ajax } from "@/_common";

    // import { Services } from "@/services";


    export default {
        name: 'MainL',
        components: {
            Navbar,
            OffCanvas,
            // Sidebar,
            SidebarMenu,
            Footer: Footer,
            // Modal,
            ModalController,
            // Toast,
        },
        // components: {
        //     "LoginPopup" : defineAsyncComponent(() => import('./components/LoginPopup.vue'))
        // },
        props: {
            data: {
                type: Object,
            },
        },
        // watch: {
        //     $route(to) {
        //     // set layout by route meta
        //     if (to.meta.layout !== undefined) {
        //         this.layout = to.meta.layout
        //     } else {
        //         this.layout = "DashboardLayout" // this is default layout if route meta is not set
        //     }
        //     },
        // },
        setup(props) {
            const store = useStore();
            const router = useRouter();

            const gpage = G.current;

            const menu_list = ref([]);

            gpage.page = '@/' + (props.data && props.data.page !== undefined && props.data.page != '') ? (props.data.page || G.defaultPage) : G.defaultPage;
            gpage.data[gpage.page] = props.data ? props.data.data || "" : "";


            // Interval for get Warnings Data list
            // if( G.intervalRef.value != null ){
            //     clearInterval(G.intervalRef.value);
            //     G.intervalRef.value = null;
            // }
            // G.intervalRef.value = setInterval(() => {
            //     Services.getWData();
            // }, G.intervalTimeRef.value);


            const getLangList = async () => {
                await ajax({
                    url: store.getLangsList(),
                    data: {},
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            G.lang_list = res.map((a) => { return { value: a.id, label: a.shortname, flag: a.flag || "🇦🇿" }; });
                        }
                    }
                });
            };

            const getSystemData = async () => {
                await ajax({
                    url: store.getSystemSettings('system'),
                    success: (x) => {
                        let res = x.data || null;
                        if ( x.status == 200 && res ) {
                            if( res.logo !== undefined ){
                                for(let a in res){
                                    if( a == 'upload_file_size' ){
                                        G.uploadedFileSize = parseInt(res[a].value);
                                    }
                                    G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                                }
                                document.getElementById("frontend_favicon1").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon2").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon3").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon_1").setAttribute("content", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon_2").setAttribute("content", G.systemData?.favicon?.value );
                            }
                            else{
                                G.systemData = res;
                            }
                            // G.systemData = res.reduce((m, o) => m.set(o.key, o), new Map);
                            // console.log(G.systemData);
                            // console.log(res.reduce((m, o) => m.set(o.key, o), new Map)); //.values();
                            // console.log(res.reduce((m, o) => m.set(o.key, {"value": o.value, "type": o.type}), new Map)); //.values();
                        }
                    },
                });
            };

            onBeforeMount(async () => {
                menu_list.value = [...menus];

                if( document.getElementsByClassName('p-dialog-mask').length > 0 ){
                    document.getElementsByClassName('p-dialog-mask')[0].remove();
                }
            });

            onMounted(async() => {
                if( document.getElementsByClassName('p-dialog-mask').length > 0 ){
                    document.getElementsByClassName('p-dialog-mask')[0].remove();
                }
                getLangList();
                getSystemData();
            });

            const setComponent = (val) => {
                // val = val.replace(/^\//, "");
                // gpage.page = G.capitalize(val);

                store.setDataTableParams();

                document.getElementsByTagName('body')[0].style='';

                gpage.page = val;
                gpage.data[gpage.page] = {};

                router.push({
                    name: val,
                    // params: {
                    //     // soldier_id: route.params.soldier_id || 2,
                    // },
                    // params: Object.assign(
                    //     {
                    //         page: 1,
                    //         perpage: prm.limit || 20,
                    //     },
                    //     route_obj.value
                    // ),
                });
            };

            // const setComponent = (val, pdata) => {
            //     val = val.replace(/^\//, "");
            //     gpage.page = G.capitalize(val);

            //     document.getElementsByTagName('body')[0].style='';

            //     gpage.page = `${pdata.page}`;
            //     gpage.data[gpage.page] = {};

            //     // return defineAsyncComponent({
            //     //     loader: () => import(`@/${pdata.page}`),
            //     //     errorComponent:
            //     //         defineAsyncComponent(() =>
            //     //             import('@/system_modules/NotFound')
            //     //         ),
            //     // });
            // };

            const currentComponent = computed(() => {
                return gpage.data[gpage.page] || {};
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`).then(
                        (mod) => {
                            return mod;
                        },
                        () => {
                            return import('@/system_modules/NotFound');
                        }
                    ),
                    loadingComponent:
                            '<center><i class="fa fa-sync fa-spin"></i></center>',
                    errorComponent: defineAsyncComponent(() => import('@/system_modules/NotFound'))
                    // hydrate: hydrateOnInteraction(['wheel', 'mouseover'])
                    // timeout: 3000,
                    // suspensible: false,
                });
            });

            // const myStrategy: HydrationStrategy = (hydrate, forEachElement) => {
            //     // forEachElement is a helper to iterate through all the root elements
            //     // in the component's non-hydrated DOM, since the root can be a fragment
            //     // instead of a single element
            //     forEachElement(el => {
            //         // ...
            //     })
            //     // call `hydrate` when ready
            //     hydrate()
            //     return () => {
            //         // return a teardown function if needed
            //     }
            // };

            // const AsyncComp = defineAsyncComponent({
            //     loader: () => import('./Comp.vue'),
            //     hydrate: myStrategy
            // });

            // const cleanup = () => {
            //     const container = document.getElementById("app");
            //     if (container)
            //     {
            //         document.body.removeChild(container);
            //         // if (app) {
            //         //     app.unmount(); //remove the instance
            //         //     app = null;
            //         // }
            //     }
            // };

            // onBeforeUnmount(() => {
            //     cleanup();
            // });

            return { G, currentComponent, loadPages, setComponent, menu_list };
        },
    };
</script>


<style lang="scss" scoped>
    .main-content {
        width: calc(100% - 275px);
        // height: calc( 100% - 50px );
        // max-height: calc( 100% - 90px );
        // margin-bottom: 60px;
    }
    /*.main {
        // height: calc( 100vh - 10px );
        max-height: calc( 100vh - 95px );
        // margin-bottom: 60px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .main > .row, .main > .row > .col-12{
        margin: 0px;
        padding: 0px;
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }*/
    // .main-content {
    //     width: calc(100% - 250px);
    //     // height: calc( 100% - 50px );
    //     // max-height: calc( 100% - 90px );
    //     // margin-bottom: 60px;
    // }
    .main-body-content {
        // height: calc( 100vh - 95px );
        // max-height: calc( 100vh - 95px );
        height: calc( 100vh - 78px );
        max-height: calc( 100vh - 78px );
        // height: calc( 100vh - 79px );
        // max-height: calc( 100vh - 79px );

        // margin-bottom: 60px;
        overflow: hidden;
        overflow-y: scroll;
        padding: 10px;
    }
    .main-body-content > .row, .main-body-content > .row > .col-12{
        margin: 0px;
        padding: 0px;
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
        .main-body-content {
            height: calc( 100vh - 103px );
            max-height: calc( 100vh - 103px );
            padding: 4px 0px;
        }
    }
</style>

